import { createApp } from 'vue'
import Card from 'ant-design-vue/es/card'
import Table from 'ant-design-vue/es/table'
import VxeUITable from 'vxe-table'
import VxeLoading from 'vxe-pc-ui/es/loading'
import 'vxe-table/es/style.css'
import 'vxe-pc-ui/es/style.css'
import './style.css'
// import './styles/theme.scss' // 引入主题样式
import App from './App.vue'
import { router, initialize as routerInitialize } from './route'
import routerGuardInitialize from './route/guard'
import { createPinia } from 'pinia'
import 'ant-design-vue/dist/reset.css'
import { useDict } from '@/utils/dict.js'
import useUserStore from './store/userStore.js'
import usePermissionStore from './store/permissionStore.js'
// import useThemeStore from './store/themeStore.js'

const initApp = async () => {
  // 创建app
  console.info('初始化app')
  const app = createApp(App)

  // 创建pinia
  console.info('创建pinia')
  const pinia = createPinia()
  app.use(pinia)
  app.config.globalProperties.useDict = useDict

  console.info('创建路由守卫')
  // 初始化主题（在 pinia 创建后立即初始化，避免页面闪烁）
  // console.info('初始化主题')
  // const themeStore = useThemeStore()
  // themeStore.initTheme()

  // 路由守卫必须在 app.use(router) 前注册，避免首次访问 /index 跳过登录
  routerGuardInitialize()

  console.info('创建router')
  const userStore = useUserStore()
  await userStore.initialize()
  const permissionStore = usePermissionStore()
  await permissionStore.initialize()

  await routerInitialize(app)

  // 在路由初始化后，再初始化权限store
  console.info('初始化权限')
  console.info('创建VxeUITable')
  app.use(VxeUITable)
  app.use(VxeLoading)

  await router.isReady()
  console.info('router准备完成')
  console.info('挂载app')
  app.mount('#app', true)
}

initApp()

Card.props.size.default = 'small'
Table.props.size.default = 'middle'
